import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatabaseServiceProvider } from '../database-service/database-service';
import * as moment from 'moment';
// import { NavController } from 'ionic-angular';
declare var dataLayer: Array<any>;

/*
  Housekeeping services required to process new order
*/

@Injectable()
export class OrderServicesProvider {

  currentLocSettings: any;

  constructor(public http: HttpClient, private afService: DatabaseServiceProvider) {
  }


  /* Saves and returns orderKey  */
  saveOrder(orderData) {
    return new Promise((resolve, reject) => {
      orderData['status'] = 'Processing'; //intermittent status before moving it to received
      this.afService.pushList('orders', orderData).then(data => {
        // orderData['key'] = data.id;
        resolve(data.id);
      }).catch(err => reject(err));
    })
  }


  /* POST payment Tasks */
  successfulOrderTasks(orderData, uid, loyality, userLoc, qrPay?) {
    return new Promise(async (resolve, reject) => {
      // 1, Save to order/cardDetails (done at server)
      // 2, Save order to users order history
      await this.saveUserOrderHistory(orderData, uid)
      // 3, award users new loyalty & append locationId to userData when user orders from new location
      if (userLoc && userLoc.length > 0) {
        await this.afService.updateObject('users/' + uid, { loyalityPoint: loyality, locationId: userLoc }).catch(err => console.log(err));
      } else {
        if(loyality){
          await this.afService.updateObject('users/' + uid, { loyalityPoint: loyality || 0 }).catch(err => console.log(err));
        }
      }
      // 4, update token - not needed for finix
      // 5, send confirmation email (moved to serverside)
      // 6, update datalayer for ga & fb
      this.updateAnalyticsDataLayer(orderData);
      // 7, clear any local storage for order
      if(!qrPay){
      this.clearlocalStorage();
      }
      resolve('done');
    });
  }
  
  failedOrderTasks(orderKey, qrPay?) {
    if(!qrPay){
    this.afService.removeObject('orders/' + orderKey).catch(err => console.log(err));
    }
  }

  saveUserOrderHistory(orderData, uid) {
    return new Promise((resolve, reject) => {
      var _data = {
        orderId: orderData.orderId,
        createdAt: orderData.createdAt,
        bookingTime: orderData.bookingTime,
        bookingDate: orderData.bookingDate,
        bookingOption: orderData.bookingOption,
        paymentType: orderData.paymentType,
        paymentAmount: orderData.paymentAmount
      }
      //if a coupon was used, capture it
      if (orderData.usedcouponkey) {
        _data['couponCodeUsed'] = orderData.usedcouponkey;
      }
      var _orderKey = orderData['key'];
      this.afService.set('users/' + uid + '/orderHistory/' + _orderKey, _data).then(res => {
          resolve('done')
        }).catch(err => reject(err))
    });
  }

  clearlocalStorage() {
    localStorage.removeItem('bookingOption');
    localStorage.removeItem('address');
    localStorage.removeItem('bookingTime');
    localStorage.removeItem('bookingDate');
    localStorage.removeItem('Cart');
    localStorage.removeItem('booking');
    localStorage.removeItem('coupon');
    localStorage.removeItem('tipAmount');
  }

  //update ga & fb analytics dataLayer
  updateAnalyticsDataLayer(orderData) {
    //data layer
    var cart = orderData.cart;
    var citems = [];
    for (var i = 0; i <= cart.length - 1; i++) {
      citems.push({
        'sku': cart[i].item.itemId,
        'name': cart[i].item.title + '-' + cart[i].item.price.pname,
        'category': cart[i].item.catId,
        'price': cart[i].item.price.value,
        'quantity': cart[i].item.itemQuantity
      })
    }
    dataLayer.push({
      'transactionId': orderData.orderId,
      'transactionAffiliation': orderData.locationId,
      'transactionTotal': orderData.paymentAmount,
      'transactionTax': orderData.tax,
      'subtotal': orderData.subtotal,
      'transactionProducts': JSON.stringify(citems)
    });
    dataLayer.push({ 'event': 'orderComplete' });
  }
}



// WEBPACK FOOTER //
// ./src/providers/order-services/order-services.ts